<template>
  <v-app>
    <router-view />
    <GlobalCommandPalette />
  </v-app>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, watch } from 'vue';
import { useAuthStore } from './stores/auth';
import { useWorkspaceStore } from './stores/workspace';

const GlobalCommandPalette = defineAsyncComponent(() => import('./components/global/GlobalCommandPalette.vue'));

const auth = useAuthStore();
const ws = useWorkspaceStore();

onMounted(async () => {
  await auth.init();
  if (auth.accessToken) {
    try { await ws.fetchWorkspaces(); } catch { /* ignore — workspaces optional during migration */ }
  }
});

watch(() => auth.accessToken, async (token, prev) => {
  if (token && !prev) {
    try { await ws.fetchWorkspaces(); } catch { /* ignore */ }
  }
});
</script>
